import { Alert, Section, Grid } from '@gogame/components';
import React, { useMemo } from 'react';
import { SpendAllocationType } from '../fields';
import { CAMPAIGNS, COST_MODELS } from '../constants';
const EMPTY_ARR = [];
export const SpendAllocationModelSection = ({
  disabled,
  campaigns = EMPTY_ARR,
}) => {
  const spendAllocationsDepends = useMemo(() => {
    return campaigns.reduce((m, c, i) => {
      return c.costModels
        ? c.costModels.reduce((mm, _, j) => {
            return [...mm, `${CAMPAIGNS}[${i}].${COST_MODELS}[${j}].type.id`];
          }, m)
        : m;
    }, EMPTY_ARR);
  }, [campaigns]);

  return (
    <Section
      title={'Spend Allocation Model'}
      prompt={
        'To be used by parent Campaign for spend distribution to GG campaigns'
      }
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Alert severity={'info'}>
            Note: Spend allocation works only when all selected campaigns use
            the same cost model and cover the same time period.
            <br />
            Supported cost models: CFF, FCFF, FCFF by Clicks.
          </Alert>
        </Grid>
        <Grid item xs={4}>
          <SpendAllocationType
            disabled={disabled}
            depends={spendAllocationsDepends}
          />
        </Grid>
      </Grid>
    </Section>
  );
};
